import React, { useState } from 'react';

import { FormattedMessage } from '../../../../../util/reactIntl';

import {
  Menu,
  MenuContent,
  MenuLabel,
  MenuItem,
  NamedLink,
  IconUserBlack,
} from '../../../../../components';

import css from './LinksAuthMenu.module.css';

const LinkComponent = props => {
  const { type = '' } = props;
  if (type === 'signup') {
    return (
      <NamedLink name="SignupPage" className={css.menuLink}>
        <span className={css.menuItemBorder} />
        <span className={css.menuLink}>
          <FormattedMessage id="TopbarDesktop.signup" />
        </span>
      </NamedLink>
    );
  }

  if (type === 'login') {
    return (
      <NamedLink name="LoginPage" className={css.menuLink}>
        <span className={css.menuItemBorder} />
        <span className={css.menuLink}>
          <FormattedMessage id="TopbarDesktop.login" />
        </span>
      </NamedLink>
    );
  }

  return null;
};

const MenuLabelContent = () => {
  return (
    <span className={css.linkMenuLabelWrapper}>
      <IconUserBlack />
    </span>
  );
};

const LinksAuthMenu = props => {
  const [isOpen, setIsOpen] = useState(false);
  const { id, links, intl } = props;

  return (
    <Menu
      id={id}
      contentPlacementOffset={24}
      contentPosition="left"
      isOpen={isOpen}
      onToggleActive={setIsOpen}
    >
      <MenuLabel className={css.linkMenuLabel} isOpenClassName={css.linkMenuIsOpen}>
        <MenuLabelContent showMoreLabel={true} isOpen={isOpen} intl={intl} />
      </MenuLabel>
      <MenuContent className={css.linkMenuContent}>
        {links.map((item, index) => {
          return (
            <MenuItem key={`${item}_${index}`}>
              <LinkComponent type={item.type} />
            </MenuItem>
          );
        })}
      </MenuContent>
    </Menu>
  );
};

export default LinksAuthMenu;
